import { selectAffiliate_actionType } from "../../actionTypes/userAction-actionTypes/selectAffiliate-actionType";

export function resetSelectAffiliateReducer() {
    return(dispatch) => {
        dispatch({
            type: selectAffiliate_actionType.RESET_SELECT_AFFILIATE_SUCCESS
        });
    };
}

export function setSelectAffiliate(data) {
    return(dispatch) => {
        if(data){
            dispatch({
                type: selectAffiliate_actionType.SET_SELECT_AFFILIATE_SUCCESS,
                payload: data
            });
        }else{
            dispatch({
                type : selectAffiliate_actionType.SET_SELECT_AFFILIATE_FAILURE
            });
        }
    };
}